import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import * as chroma from 'chroma-js';

import { Dimensions } from '../../models';

@Component({
    selector: '[aaColorPicker]',
    templateUrl: './color-picker.component.html',
    styleUrls: [
        './color-picker.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColorPickerComponent implements OnInit
{
    @Input() dimensions: Dimensions;
    @Output() newPalette: EventEmitter<string> = new EventEmitter<string>();
    public open: boolean = false;
    public width: number = 75;
    public height: number = 15;
    public transform: string = 'translate(0,0)';
    public brewer: any = chroma.default.brewer;
    public palettes: string[] = ['OrRd', 'PuBu', 'BuPu', 'BuGn'];
    public selectedPalette: string = 'OrRd';
    public numbers: number[];

    constructor()
    {
        this.numbers = Array(5).fill(0).map((x, i) => i);
    }

    ngOnInit ()
    {
        this.transform = `translate(${this.dimensions.boundedWidth}px, ${7 * this.dimensions.marginTop}px)`;
    }

    onClickOpen ()
    {
        this.open = !this.open;
    }

    onSelectedPaletteChanged (palette: string)
    {
        this.open = !this.open;
        this.selectedPalette = palette;
        this.newPalette.emit(palette);
    }
}
